import {
  AlertDialog,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@common/components/ui/alert-dialog"
import { Button } from "@common/components/ui/button"

export function ConfirmDialog({
  title,
  description,
  action,
  pendingAction,
  tone = "destructive",
  cancelLabel = "Cancel",
  open = true,
  pending = false,
  disabled = false,
  onConfirm,
  onCancel,
  children,
}: {
  title: string
  description?: React.ReactNode
  action: string
  pendingAction?: string
  tone?: "destructive" | "default"
  cancelLabel?: string
  open?: boolean
  pending?: boolean
  disabled?: boolean
  onConfirm: () => void
  onCancel: () => void
  children?: React.ReactNode
}): React.ReactElement {
  return (
    <AlertDialog
      open={open}
      onOpenChange={(next) => {
        if (!next && !pending) onCancel()
      }}
    >
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>{title}</AlertDialogTitle>
          {description && (
            <AlertDialogDescription>{description}</AlertDialogDescription>
          )}
        </AlertDialogHeader>
        {children}
        <AlertDialogFooter>
          <AlertDialogCancel disabled={pending}>
            {cancelLabel}
          </AlertDialogCancel>
          <Button
            variant={tone === "destructive" ? "destructive" : "primary"}
            loading={pending}
            disabled={disabled}
            onClick={onConfirm}
          >
            {pending && pendingAction ? pendingAction : action}
          </Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
}
